<template>
  <div class="overseasWarehouseConfig_box">
    <template v-if="warehouseType === 2">
      <!--请选择第三方服务商-->
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1002258') }}</h2>
        </template>
        <div class="thirdPartyWarehouse_box">
          <div v-for="(item,index) in thirdPartyWarehouseData" class="thirdPartyWarehouse_item"
            :class="thirdPartyWarehouseStyle(item)" @click="selectThirdPartyWarehouse('select',index)">
            <img :src="item.logoImg" :alt="item.carrierName" :width="184" :height="43">
            <p class="thirdPartyWarehouse_title">{{ item.carrierName }}</p>
          </div>
        </div>
      </Card>
      <!--请完善服务商信息-->
      <Card :bordered="false" dis-hover v-if="carrierCode">
        <template #title>
          <h2 class="title_box">{{ $t('key1002259') }}</h2>
        </template>
        <!--开启仓库-->
        <h3 class="color-333 font-size-13">{{ $t('key1002260') }}</h3>
        <Divider style="margin: 5px 0 15px 0"/>
        <template v-if="!openWarehouseText">
          <RadioGroup v-model="warehouseId" @on-change="warehouseIdChange">
            <Radio class="ml15 mb12" v-for="item in overseasWarehouseList" :disabled="warehouseDisabled"
              :label="item.warehouseId">{{ item.warehouseName }}</Radio>
          </RadioGroup>
        </template>
        <template v-else>
          <span>{{ openWarehouseText }}</span>
        </template>
      </Card>
    </template>
    <!--仓库可用物流配置-->
    <Card :bordered="false" dis-hover>
      <template #title>
        <h2 class="title_box">{{ $t('key1002261') }}</h2>
      </template>
      <!--海外仓平台物流-->
      <template v-if="warehouseType === 2 && overseasWarehousePlatformLogisticsData.length>0">
        <h3 class="color-333 font-size-13">{{ selectOverseasWarehouseObj?.carrierName + $t('key1002257') }}</h3>
        <Divider style="margin: 5px 0 15px 0"/>
        <Checkbox class="mb10 ml15" v-model="selectAllPlatformLogistics" @on-change="handleCheckAllLogisticsChange"
          :indeterminate="platformLogisticsIndeterminate">{{ $t('key1000110') }}
        </Checkbox>
        <CheckboxGroup v-model="overseasWarehousePlatformLogisticsValues"
          class="flex flex-wrap mb24" @on-change="handleSinglePlatformLogisticsChange">
          <Checkbox class="mb10 ml15 mr11" v-for="ele in overseasWarehousePlatformLogisticsData" :label="ele.systemShippingMethodId" :key="ele.systemShippingMethodId">
            {{ ele.carrierShippingMethodName }}
          </Checkbox>
        </CheckboxGroup>
      </template>
      <!--平台基础物流-->
      <template>
        <h3 class="color-333 font-size-13">{{ $t('key1000564') }}</h3>
        <Divider style="margin: 5px 0 15px 0"/>
        <Tabs v-model="logisticsType" :animated="false" @on-click="changeTab">
          <TabPane :label="$t('key1002255')" name="onlineLogistics"></TabPane>
          <TabPane :label="$t('key1002256')" name="offlineLogistics"></TabPane>
        </Tabs>
        <!--线上物流-->
        <template v-if="logisticsType === 'onlineLogistics'">
          <Tabs type="card" :animated="false" v-model="logisticsChannelsType" @on-click="changeChildTab">
            <TabPane v-for="(item,index) in onlineLogisticsData"
              :key="item.tabType + '_' + index + '_' + logisticsType"
              :label="item.carrierName" :name="item.tabType + '_' + index">
              <Checkbox class="display-inline-block mb15" v-model="item.selectAllLogisticsOptions"
                :indeterminate="item.indeterminate" @on-change="handleCheckAllChange(item)">{{ $t('key1000110') }}
              </Checkbox>
              <CheckboxGroup :key="item.tabType + '_' + index + '_' + item.shippingMethodIdList.join(',')"
                v-model="item.shippingMethodIdList" class="flex flex-wrap" @on-change="handleSingleChange(item)">
                <Checkbox class="mb10 mr25" v-for="ele in item.carrierShippingMethods" :label="ele.shippingMethodId">
                  {{ ele.carrierShippingMethodName }}
                </Checkbox>
              </CheckboxGroup>
            </TabPane>
          </Tabs>
        </template>
        <!--线下物流-->
        <template v-if="logisticsType === 'offlineLogistics'">
          <Tabs type="card" :animated="false" v-model="logisticsChannelsType" @on-click="changeChildTab">
            <TabPane v-for="(item,index) in offlineLogisticsData"
              :key="item.tabType + '_' + index + '_' + logisticsType"
              :label="item.carrierName" :name="item.tabType + '_' + index">
              <Checkbox class="display-inline-block mb15" v-model="item.selectAllLogisticsOptions"
                :indeterminate="item.indeterminate" @on-change="handleCheckAllChange(item)">{{ $t('key1000110') }}
              </Checkbox>
              <CheckboxGroup :key="item.tabType + '_' + index + '_' + item.shippingMethodIdList.join(',')"
                v-model="item.shippingMethodIdList" class="flex flex-wrap" @on-change="handleSingleChange(item)">
                <Checkbox class="mb10 mr25" v-for="ele in item.carrierShippingMethods" :label="ele.shippingMethodId">
                  {{ ele.carrierShippingMethodName }}
                </Checkbox>
              </CheckboxGroup>
            </TabPane>
          </Tabs>
        </template>
      </template>
    </Card>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {THIRD_PARTY_WAREHOUSE} from "@/utils/enum";
import {_handleMultilingualFields} from "@/utils/common";

export default {
  name: 'overseasWarehouseConfigModule',
  mixins: [Mixin],
  props: {
    // 仓库类型 1:自营  2:第三方
    warehouseType: {
      type: Number,
      default: 1
    },
    // 第三方服务商列表
    thirdPartyWarehouseList: {
      type: Array,
      default: () => []
    },
    // 当前发货地所在的国家
    countryOfDeliveryList: {
      type: Array,
      default: () => []
    },
    // 编辑状态类型 look 、add、edit
    warehouseOptionType: {
      type: String,
      default: 'add'
    }
  },
  data() {
    let v = this;
    return {
      thirdPartyWarehouseData: [],
      warehouseId: null,
      overseasWarehouseList: [],
      selectAllPlatformLogistics: false,
      platformLogisticsIndeterminate: false,
      overseasWarehousePlatformLogisticsValues: [],
      overseasWarehousePlatformLogisticsData: [],
      logisticsType: 'onlineLogistics',
      logisticsChannelsType: 'onlineLogistics_0',
      offlineLogisticsData: [],
      onlineLogisticsData: [],
      openWarehouseText: '',
      carrierCode: null,
      basicLogisticsData: [],
      ymsWarehouseId: null,
      overseasWarehouseData: [],
      selectOverseasWarehouseObj: null, // 当前选中的海外仓信息
    }
  },
  computed: {
    // 第三方仓库编辑禁用标识
    warehouseDisabled() {
      return ['look', 'edit'].includes(this.warehouseOptionType) && this.warehouseType === 2;
    }
  },
  methods: {
    // 初始化数据
    async initOverseasWarehouseConfigData(obj) {
      await this.getPlatformLogisticsData();
      let newList = JSON.parse(JSON.stringify(this.thirdPartyWarehouseList));
      newList.forEach((item) => {
        item.logoImg = null;
        item.selected = false;
        let newItem = THIRD_PARTY_WAREHOUSE.find((item2) => {
          return item.carrierCode === item2.carrierCode
        });
        if (newItem) {
          item.logoImg = newItem.logoImg;
        }
      });
      this.thirdPartyWarehouseData = newList;
      // 处理回显
      if (obj) {
        this.ymsWarehouseId = obj.ymsWarehouseId;
        this.warehouseId = obj.apiWarehouseId;
        await this.getOverseasWarehouseLogisticsData(obj.apiWarehouseId);
        // 第三方服务商、开启仓库
        this.thirdPartyWarehouseData.forEach((item, index) => {
          item.selected = false;
          if (item.carrierCode === obj.apiCode) {
            item.selected = true;
            this.selectThirdPartyWarehouse('update', index)
          }
        });
        // 海外仓--平台物流
        this.overseasWarehousePlatformLogisticsValues = [];
        let thirdCarrierShippingMethods = obj.thirdCarrierShippingMethods || [];
        if (thirdCarrierShippingMethods.length > 0) {
          thirdCarrierShippingMethods.forEach((item) => {
            if (item.systemShippingMethodId) {
              this.overseasWarehousePlatformLogisticsValues.push(item.systemShippingMethodId);
            }
          });
          this.handleSinglePlatformLogisticsChange();
        }
        // 平台基础物流
        let carrierShippingMethods = obj.carrierShippingMethods || [];
        this.onlineLogisticsData.forEach((item) => {
          let shippingMethodIdList = [];
          carrierShippingMethods.forEach((item2) => {
            if (item.carrierId === item2.carrierId) {
              if (item2.shippingMethodId) {
                shippingMethodIdList.push(item2.shippingMethodId);
              }
            }
          });
          item.shippingMethodIdList = this.uniqueFunc(shippingMethodIdList);
          this.handleSingleChange(item);
        });
        this.offlineLogisticsData.forEach((item) => {
          let shippingMethodIdList = [];
          carrierShippingMethods.forEach((item2) => {
            if (item.carrierId === item2.carrierId) {
              if (item2.shippingMethodId) {
                shippingMethodIdList.push(item2.shippingMethodId);
              }
            }
          });
          item.shippingMethodIdList = this.uniqueFunc(shippingMethodIdList);
          this.handleSingleChange(item);
        });
      }
    },
    // 切换物流方式
    changeTab(name) {
      this.logisticsType = name;
      let data = name === 'offlineLogistics' ? this.offlineLogisticsData : this.onlineLogisticsData;
      if (data.length > 0) {
        this.logisticsChannelsType = data[0].tabType + '_0';
      }
      // 强制更新以确保 CheckboxGroup 正确渲染
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    // 切换物流渠道
    changeChildTab() {
      this.$nextTick(() => {
        this.onlineLogisticsData = [...this.onlineLogisticsData];
        this.offlineLogisticsData = [...this.offlineLogisticsData];
        this.$forceUpdate();
      });
    },
    // 全选当前物流商下的所有渠道
    handleCheckAllChange(item) {
      if (item.selectAllLogisticsOptions) {
        this.$set(item, 'shippingMethodIdList', item.carrierShippingMethods.map(c => c.shippingMethodId));
      } else {
        this.$set(item, 'shippingMethodIdList', []);
      }
      item.indeterminate = false;
      this.$nextTick(() => this.$forceUpdate());
    },
    // 勾选物流渠道
    handleSingleChange(item) {
      const checkedCount = item.shippingMethodIdList.length || 0;
      const totalCount = item.carrierShippingMethods?.length || 0;
      item.selectAllLogisticsOptions = checkedCount === totalCount && totalCount > 0;
      item.indeterminate = checkedCount > 0 && checkedCount < totalCount;
      this.$nextTick(() => this.$forceUpdate());
    },
    // 选择第三方服务商
    selectThirdPartyWarehouse(optionType, currentIndex) {
      const handleData = () => {
        this.thirdPartyWarehouseData.map((item, index) => {
          item.selected = false;
          if (index === currentIndex) {
            this.$set(this.thirdPartyWarehouseData[currentIndex], 'selected', true);
            this.getThirdPartyWarehouseInfo();
            this.handlePlatformLogisticsData(this.basicLogisticsData);
            this.selectOverseasWarehouseObj = item;
          }
        });
        this.$forceUpdate();
      };
      if (optionType === 'update') {
        handleData();
      } else {
        if (!this.warehouseDisabled) {
          handleData();
        }
      }
    },
    // 获取服务商可用仓库信息
    getThirdPartyWarehouseInfo() {
      const handleData = (data) => {
        if (this.countryOfDeliveryList.length > 0) {
          this.openWarehouseText = '';
          let newData = data.filter(item => {
            return this.countryOfDeliveryList.includes(item.countryCode);
          });
          if (newData.length > 0) {
            if (this.warehouseOptionType === 'add') {
              this.warehouseId = newData[0].warehouseId;
              this.getOverseasWarehouseLogisticsData(this.warehouseId);
            }
            this.overseasWarehouseList = newData;
          } else {
            this.openWarehouseText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002253');
          }
        } else {
          this.openWarehouseText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002254');
        }
      }
      let carrierCode = this.thirdPartyWarehouseData.find(item => item.selected)?.carrierCode || null;
      if (carrierCode && this.carrierCode !== carrierCode) {
        this.overseasWarehouseList = [];
        this.carrierCode = carrierCode;
        let url = api.get_carrier_warehouses.replace('{carrierCode}', this.carrierCode);
        this.axios.get(url).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            this.overseasWarehouseData = data;
            handleData(data);
          }
        });
      } else {
        handleData(this.overseasWarehouseData);
      }
    },
    // 获取平台基础物流数据
    getPlatformLogisticsData() {
      this.basicLogisticsData = [];
      return new Promise((resolve, reject) => {
        this.axios.get(api.get_carrier_queryForEnableCarriers).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            this.basicLogisticsData = data;
            this.handlePlatformLogisticsData(data);
            resolve(data)
          }
        })
      });
    },
    // 处理平台基础物流数据   isOnline: 1 线上物流  0 线下物流   carrierCode: temuHalfTl  tiktok
    handlePlatformLogisticsData(data) {
      let v = this;
      v.logisticsType = 'onlineLogistics';
      v.logisticsChannelsType = 'onlineLogistics_0';
      v.onlineLogisticsData = [];
      v.offlineLogisticsData = [];
      if (data.length > 0) {
        const warehouseCarrierMap = {
          winitoutstore: ['temuHalfTl', 'tiktok'], // 万邑通仓库只需要配置：Tiktok物流、TEMU半托管线上发货
          miyunoutstore: ['tiktok'] // 米雲仓仓库只需要配置：Tiktok物流
        };
        let result = data;
        // 第三方仓库
        if (v.warehouseType === 2) {
          const carrierList = warehouseCarrierMap[v.carrierCode];
          if (carrierList) {
            result = data.filter(item => carrierList.includes(item.carrierCode));
          }
        }
        handleData(result);
      }

      function handleData(data) {
        data.forEach((item) => {
          item.tabType = item.isOnline === 1 ? 'onlineLogistics' : 'offlineLogistics';
          item.shippingMethodIdList = [];
          v.$set(item, 'shippingMethodIdList', []);
          v.$set(item, 'selectAllLogisticsOptions', false);
          v.$set(item, 'indeterminate', false);
          item.carrierShippingMethods = (Array.isArray(item.carrierShippingMethods) ? item.carrierShippingMethods : [])
            .filter(ele => ele.status === 1)
            .map(ele => {
              ele.carrierShippingMethodName = _handleMultilingualFields(ele.carrierShippingMethodName)
              return ele;
            });
        });
        // 线上物流
        v.onlineLogisticsData = data.filter(item => item.isOnline === 1 && item.carrierShippingMethods.length > 0);
        // 线下物流
        v.offlineLogisticsData = data.filter(item => item.isOnline === 0 && item.carrierShippingMethods.length > 0);
      }
    },
    // 选择开启仓库
    warehouseIdChange(value) {
      this.getOverseasWarehouseLogisticsData(value);
    },
    // 获取海外仓--平台物流数据
    getOverseasWarehouseLogisticsData(apiWarehouseId) {
      return new Promise((resolve) => {
        this.selectAllPlatformLogistics = false;
        this.platformLogisticsIndeterminate = false;
        this.overseasWarehousePlatformLogisticsValues = [];
        this.overseasWarehousePlatformLogisticsData = [];
        let query = `?apiWarehouseId=${apiWarehouseId}&ymsWarehouseId=${this.ymsWarehouseId}`;
        this.axios.get(api.get_ymsWarehouse_getEnableThirdShippingMethods + query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              this.overseasWarehousePlatformLogisticsData = data.thirdCarrierShippingMethods || [];
            }
            resolve(data)
          }
        });
      });
    },
    // 海外仓平台物流 - 全选/取消全选
    handleCheckAllLogisticsChange() {
      if (this.selectAllPlatformLogistics) {
        this.overseasWarehousePlatformLogisticsValues = this.overseasWarehousePlatformLogisticsData.map(ele => ele.systemShippingMethodId);
      } else {
        this.overseasWarehousePlatformLogisticsValues = [];
      }
      this.platformLogisticsIndeterminate = false;
      this.$nextTick(() => this.$forceUpdate());
    },
    // 海外仓平台物流--> 当勾选单个渠道时触发
    handleSinglePlatformLogisticsChange() {
      const checkedCount = this.overseasWarehousePlatformLogisticsValues.length;
      const totalCount = this.overseasWarehousePlatformLogisticsData.length;
      this.selectAllPlatformLogistics = checkedCount === totalCount;
      this.platformLogisticsIndeterminate = checkedCount > 0 && checkedCount < totalCount;
      this.$nextTick(() => this.$forceUpdate());
    },

    // 实时更新海外仓相关配置信息
    getOverseasWarehouseConfig() {
      let logisticsData = [...this.offlineLogisticsData, ...this.onlineLogisticsData];
      let obj = {
        apiWarehouseCode: null,
        apiWarehouseId: null,
        apiWarehouseName: null,

        apiInterface: null,
        carrierCode: null,

        systemShippingMethodIds: this.overseasWarehousePlatformLogisticsValues, // 启用的三方物流渠道
        carrierShippingMethodWarehouses: [], // 适用仓库的物流渠道
      };
      // 第三方服务商
      this.thirdPartyWarehouseData.forEach((item) => {
        if (item.selected) {
          obj.carrierCode = item.carrierCode;
          obj.apiInterface = item.apiInterface;
        }
      });
      // 开启仓库
      this.overseasWarehouseList.forEach((item) => {
        if (this.warehouseId === item.warehouseId) {
          obj.apiWarehouseCode = item.warehouseCode;
          obj.apiWarehouseId = item.warehouseId;
          obj.apiWarehouseName = item.warehouseName;
        }
      });
      // 平台基础物流（适用仓库）
      logisticsData.forEach((item) => {
        obj.carrierShippingMethodWarehouses.push(...item.shippingMethodIdList);
      });
      return obj;
    },
    // 重置数据
    resetData() {
      this.thirdPartyWarehouseData = [];
      this.warehouseId = null;
      this.overseasWarehouseList = [];
      this.selectAllPlatformLogistics = false;
      this.platformLogisticsIndeterminate = false;
      this.overseasWarehousePlatformLogisticsValues = [];
      this.overseasWarehousePlatformLogisticsData = [];
      this.logisticsType = 'onlineLogistics';
      this.logisticsChannelsType = 'onlineLogistics_0';
      this.offlineLogisticsData = [];
      this.onlineLogisticsData = [];
      this.overseasWarehouseData = [];
      this.openWarehouseText = '';
      this.carrierCode = null;
      this.selectOverseasWarehouseObj = null;
      this.basicLogisticsData = [];
      this.ymsWarehouseId = null;
    },
    // 设置第三方服务商样式
    thirdPartyWarehouseStyle(item) {
      let className = '';
      if (item.selected) {
        if (this.warehouseDisabled) {
          className = 'thirdPartyWarehouse_item_active_disabled';
        } else {
          className = 'thirdPartyWarehouse_item_active';
        }
      } else {
        if (this.warehouseDisabled) {
          className = 'thirdPartyWarehouse_item_disabled';
        }
      }
      return className;
    }
  },
  watch: {
    // 发货地所在国家code
    countryOfDeliveryList: {
      handler(value) {
        this.openWarehouseText = '';
        if (!value?.length) {
          this.openWarehouseText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002254')
        }
        this.getThirdPartyWarehouseInfo();
      },
      deep: true
    },
    // 监听仓库类型
    warehouseType: {
      handler(value) {
        this.handlePlatformLogisticsData(this.basicLogisticsData);
      }
    }
  },
  components: {}
};
</script>

<style lang="less" scoped>
.overseasWarehouseConfig_box /deep/ {
  .title_box {
    color: #333;
    font-size: 14px;
    font-weight: bold;
  }

  .thirdPartyWarehouse_box {
    display: flex;
    flex-wrap: wrap;
    text-align: center;

    .thirdPartyWarehouse_item {
      margin: 0 15px 20px 0;
      padding: 8px;
      cursor: pointer;
      border: 2px solid transparent;

      .thirdPartyWarehouse_title {
        font-size: 13px;
        color: #333;
        margin-top: 4px;
      }

      &:hover {
        border-radius: 8px;
        overflow: hidden;
        border: 2px solid #96C5F7;
        background-color: #E4F0FD;
      }
    }

    .thirdPartyWarehouse_item_active, .thirdPartyWarehouse_item_active_disabled {
      border-radius: 8px;
      overflow: hidden;
      border: 2px solid #96C5F7;
      background-color: #E4F0FD;
    }

    .thirdPartyWarehouse_item_active_disabled {
      cursor: not-allowed !important;
    }

    .thirdPartyWarehouse_item_disabled {
      margin: 0 15px 20px 0;
      padding: 8px;
      cursor: not-allowed;
      border: 2px solid transparent;

      &:hover {
        border-radius: 8px;
        overflow: hidden;
      }
    }
  }
}
</style>
